import { render, staticRenderFns } from "./category_table.vue?vue&type=template&id=4b970bbc"
import script from "./category_table.vue?vue&type=script&lang=js"
export * from "./category_table.vue?vue&type=script&lang=js"
import style0 from "./category_table.vue?vue&type=style&index=0&id=4b970bbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports